import { useEffect, useState } from 'react'
import { CRUD } from '../../../../../../utils/enums'
import { InputModel } from '../../../../../../utils/types'
import { Item } from '../../../../../../utils/types/generals'
import { getPreviousYears, monthYear } from '../../../../../../utils/constants/date_month'

export const initialFilterValues = {
  status: '',
  search: '',
}

export const useFilterDetail = () => {
  return {
    search: {
      label: 'Buscar departamento',
      name: 'search',
    },
    status: {
      label: 'Estado',
      name: 'status',
    },
  }
}

export const initialValues = {
  limitFolio: {
    label: 'reportFolio.setting.limitFolio',
    translate: true,
    name: 'limitFolio',
    type: 'switch',
    value: false,
    title: 'Cantidad máxima de folios',
  },
  maxRejections: {
    label: 'general.tags.maxRejections',
    translate: true,
    name: 'maxRejections',
    type: 'switch',
    value: false,
    title: 'Cantidad máxima de rechazos en folios correctivos',
  },
  enableSurvey: {
    label: 'reportFolio.setting.enableSurvey',
    translate: true,
    name: 'enableSurvey',
    type: 'check',
    value: false,
  },
} as { [x: string]: InputModel }

export const initialData = {
  name: null,
  email: null,
  phone: null,
}

export const initialTable = {
  column: [],
  row: [],
}

export const useMenuItems = (styles: any) => [
  {
    value: CRUD.EDIT,
    label: 'Editar departamento',
  },
  {
    value: CRUD.DELETE,
    label: 'Eliminar departamento',
  },
]

export const input = {
  areas: {
    label: 'general.tags.area',
    translate: true,
    name: 'area',
    type: 'filter-select',
    items: [],
    value: null,
  },
  deparmets: {
    label: 'general.tags.department',
    translate: true,
    name: 'users',
    type: 'filter-select',
    items: [],
    value: null,
  },
} as { [x: string]: InputModel }


const size = {
  xl: 6,
  lg: 6,
  md: 6,
  sm: 6,
  xs: 6,
}
export const formData: Record<string, string> = {
  search: 'search',
  createYear: 'year',
  month: 'month',
  from: 'date_init',
  to: 'date_end',
  area: 'areas_ids',
  department: 'departments_ids',
}
export const formatFilter = {
  search: 'search',
  createYear: 'year',
  month: 'month',
  from: 'date_init',
  to: 'date_end',
  area: 'areas_ids',
  department: 'departments_ids',
  unit: 'stores_ids',
  division: 'division_ids',
  user: 'user_ids',
  userType: 'user_type_ids',
  status: 'status_ids',
  canResponse: 'can_response',
}
export const useFilterInputs = ({ items }: { items: { areas: Item[] } }) => {
  const [input, setInput] = useState<Record<string, InputModel>>({
    search: {
      label: 'general.search',
      translate: true,
      name: 'search',
      type: 'text',
      value: null,
    },
    createYear: {
      label: 'general.filterDate.year',
      translate: true,
      name: 'createYear',
      type: 'filter-select',
      items: getPreviousYears(),
      value: null,
      size: size,
    },
    month: {
      label: 'general.filterDate.month',
      translate: true,
      name: 'month',
      type: 'filter-select',
      items: monthYear.map((e) => ({
        ...e,
        value: e.value + 1,
    })),
      value: null,
      size: size,
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: size,
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: size,
    },
    area: {
      label: 'general.tags.areas',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
    },
    department: {
      label: 'general.tags.departments',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
    },
  })

  useEffect(() => {
    setInput(prev => ({
      ...prev,
      area: {
        ...prev.area,
        items: items.areas ?? []
      }
    }))
  }, [items.areas])
  return {input, setInput}
}
export const accept = ['png', 'jpg', 'jpeg']
